import Vue from 'vue'

export default {
  fetchConfigurations () {
    return Vue.http.get(window.API_URL + 'doctors/configurations')
  },

  fetchConsultationRequestsDetails () {
    return Vue.http.get(window.API_URL + 'doctors/consultation_requests/fetch_all_requests')
  },

  fetchQueries () {
    return Vue.http.get(window.API_URL + 'doctors/consultation_requests/fetch_queries')
  },

  fetchActiveConsultationsDetails () {
    return Vue.http.get(window.API_URL + 'doctors/consultation_requests/ongoing_consultations')
  },

  fetchPastConsultationsDetails (page = 1) {
    return Vue.http.get(window.API_URL + 'doctors/consultation_requests/past_consults?page=' + page)
  },

  fetchActiveOfflineConsultationsDetails () {
    return Vue.http.get(window.API_URL + 'doctors/active_offline_consultations')
  },

  fetchPastOfflineConsultationsDetails (page = 1) {
    return Vue.http.get(window.API_URL + 'doctors/past_offline_consults?page=' + page)
  }
}



// WEBPACK FOOTER //
// ./src/api/initialise_store.js